// @TODO <HEALTH2019>
// @TODO Added $rootScope and zochaUnifiedInsuranceService
App.controller('ZochManageCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', 'zochaLifeInsuranceService', 'monthsService', '$timeout', '$filter', 'zochaInsuranceService', '$rootScope' ,'zochaUnifiedInsuranceService', 'zochaHealthInsuranceService', 'zochaPzuwHealthInsuranceService', 'packageService', function ($scope, $sce, $state, $http, $mdDialog, Config, zochaLifeInsuranceService, monthsService, $timeout, $filter, zochaInsuranceService, $rootScope, zochaUnifiedInsuranceService, zochaHealthInsuranceService, zochaPzuwHealthInsuranceService, packageService) {
// @TODO </HEALTH2019>
    $scope.page = 'zoch_manage';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Zarządzaj';
    $scope.$emit('step', $scope.step);

    $scope.link = '';
    $scope.$emit('link', $scope.link);

    $timeout(function () {
        $('#barcode').find('input').focus();
    });


    $scope.uploadDeclaration = function (id) {
        var vm = this;

        if (!vm.uploadDeclarationForm.$valid) {
            return 0;
        }

// @TODO <HEALTH2019>
        if ($rootScope.CONFIGURATOR.zoch.isUnifiedEnterBarcodeEnabled) {
            var uploadDeclarationTypes = ['healthInsuranceDeclarationResponse', 'insuranceDeclarationResponse', 'lifeInsuranceDeclarationResponse'];
            zochaUnifiedInsuranceService.enterOriginalCopyBarcodeBody(id).then(function (data) {

                if(data.status === 403){
                    showErrorPopup("", data.status);
                    return;
                }

                //angular.forEach(uploadDeclarationTypes, function (currentType) {

                    var declaration = data.data;
                    if (!declaration) {
                        return;
                    }
                    if (data.status === 200) {
                        showSuccessPopup(declaration, id);
                    } else {
                        showErrorPopup(declaration.message, data.status);
                    }
               // });

                resetForm($scope);
            }).catch(function (err) {
                resetForm($scope);
            });

            return;
        }
// @TODO </HEALTH2019>

        /**
         * Tries to find life insurance to upload in the system;
         */
        zochaLifeInsuranceService.enterOriginalCopyBarcode(id)
            .then(function (data) {
                console.log('uploadDeclaration', data.data);
                if (data.status === 200) {
                    showSuccessPopup(data.data, id);
                    resetForm(vm);
                } else {
                    tryNormalInsurance(vm, id);
                }
            });
    };

    /**
     * Tries to find health insurance to upload in the system;
     * @param vm
     * @param id
     */
    function tryNormalInsurance(vm, id) {
        zochaInsuranceService.enterOriginalCopyBarcode(id)
            .then(function (data) {
                if (data.status === 200) {
                    showSuccessPopup(data.data, id);
                } else {
                    // @TODO <HEALTH2019>
                    showErrorPopup(data.data.message, data.status);
                    // @TODO </HEALTH2019>
                }
                resetForm(vm);
            })
    }

    /**
     * Displays popup on success;
     * @param data
     * @param id
     */
    function showSuccessPopup(data, id) {
        if (!data.replacedDeclaration) {
            if (data.userDeclarationNeeded) {
                $scope.showPopUp('', '', 'Aby deklaracja została aktywowana musi zostać wczytana deklaracja dla Pracownika w Wariancie Rodzina lub Ochrona.', '', '', true);
            } else {
                $scope.showPopUp('', '', 'Dostarczenie dokumentu nr ' + id + ' zostało oznaczone poprawnie w systemie', '', '', true);
            }
        } else if (data.userDeclarationNeeded) {
            $scope.showPopUp('', '', 'Aby deklaracja została aktywowana musi zostać wczytana deklaracja dla Pracownika w Wariancie Rodzina lub Ochrona.', '', '', true);
        } else {
            $scope.showPopUp('', '', 'Dostarczony dokument nr ' + id + ' zastępuje w systemie dokument nr ' + data.replacedDeclaration.barcode + '. Zmiany będą obowiązywać od ' + $filter('dateFormatter')(data.replacedDeclaration.endDateBasedOnWithdrawalDate), '', '', true);
        }
    }

    // @TODO <HEALTH2019>
    /**
     * Displays popup on error;
     * @param message
     * @param status
     */
    function showErrorPopup(message, status) {
        if (status === 403) {
            popupUnauthorized();
            return;
        }
        // @TODO </HEALTH2019>
        switch (message) {
            case 'DeclarationNotExistsException':
                popupDeclarationNotExists();
                break;
            case 'OriginalCopyAlreadyEnteredException':
                popupOriginalCopyAlreadyEntered();
                break;
            case 'WrongStatusException':
                popupWrongStatus();
                break;
            default:
                popupDefault();
        }

// @TODO <HEALTH2019>
        function popupUnauthorized() {
            $scope.showPopUp('', '', 'Nie posiadasz uprawień do obsługi wskazanej deklaracji.', '', '', false);
        }
// @TODO </HEALTH2019>

        function popupDeclarationNotExists() {
            $scope.showPopUp('', '', 'W systemie nie istnieje podany numer deklaracji. W celu wyjaśnienia sytuacji, skontaktuj się z administratorem.', '', '', false);
        }

        function popupOriginalCopyAlreadyEntered() {
            $scope.showPopUp('', '', 'W systemie jest już oznaczone dostarczenie oryginału dokumentu.', '', '', false);
        }

        function popupWrongStatus() {
            $scope.showPopUp('', '', 'Wskazana deklaracja jest nieaktywna! Nie można jej już aktywować. W celu wyjaśnienia sytuacji, skontaktuj się z administratorem.', '', '', false);
        }

        function popupDefault() {
            $scope.showPopUp('', 'Błędny kod', 'Kod deklaracji nie występuje w systemie. Spróbuj wprowadzić kod ponownie.', '', '', false);
        }
    }

    function resetForm(vm) {
        $scope.barcode = '';

        vm.uploadDeclarationForm.$setPristine();
        vm.uploadDeclarationForm.$setUntouched();
        vm.uploadDeclarationForm.$submitted = false;
    }

    monthsService.dataMonthsList().then(function (data) {
        $scope.months = data.data.data;
        $scope.years = years();

// @TODO <HEALTH2019>
        if ($rootScope.CONFIGURATOR.isLifeInsuranceEnabled && (!$rootScope.CONFIGURATOR.zoch.checkRights || $filter('prepareRights')('ZOCHA_PZU'))) {
            setNow();
        }
        if ($rootScope.CONFIGURATOR.isHealthInsuranceEnabled && (!$rootScope.CONFIGURATOR.zoch.checkRights || $filter('prepareRights')('ZOCHA_POLMED'))) {
            $scope.healthReport.setNowHealth();
        }
        if ($rootScope.CONFIGURATOR.healthInsurancePzuwEnabled && (!$rootScope.CONFIGURATOR.zoch.checkRights || $filter('prepareRights')('ZOCHA_TUW_PZUW'))) {
            $scope.healthPzuwReport.initialize();
        }
// @TODO </HEALTH2019>
    });

    function setNow() {
        var now = $filter('nowYearAndMonth')('');
        $scope.year = now.year;
        $scope.month = now.month;

        $scope.filterTransfer();
    }

    var page = 0;
    $scope.current = page;
    $scope.pageSize = 10;

    $scope.pageChanged = function (page) {
        loadTransfers(page);
        $scope.current = page;
    };

    function loadTransfers(page) {
        var criteria = {
            month: $scope.month,
            year: $scope.year
        }
        zochaLifeInsuranceService.dataTransferList(criteria).then(function (data) {
            if (data.status === 200) {
                $scope.transfers = data.data.data;
                $scope.numberOfPages = data.data.pages;
            }
        });
    }

    $scope.transferSend = function(id, sum) {
        if (!sum) {
            return 0;
        }

        var data = {
            branch: {
                id: id
            },
            month: $scope.month,
            year: $scope.year
        }
        zochaLifeInsuranceService.sendTransfer(data).then(function (data) {
            if (data.status === 200) {
                loadTransfers($scope.current);
            }
        });
    }

    $scope.filterTransfer = function(type) {
        var now = $filter('nowYearAndMonth')('');

        // min block
        if ($scope.year === 2018) {
            $scope.minMonth = 8;

            if (type === 'YEAR') {
                $scope.month = 8;
            }
        } else {
            $scope.minMonth = 1;
        }

        // max block
        if ($scope.year === now.year) {
            $scope.maxMonth = now.month;
        } else {
            $scope.maxMonth = 12;
        }

        loadTransfers(page);
    };

    function years() {
        var years = [];
        var startYear = 2018;
        var now = $filter('nowYearAndMonth')('');

        while (startYear <= now.year + 2) {
            years.push(startYear);
            startYear++;
        }

        return years;
    }

    function PopUpInfoCtrl($scope, $mdDialog, locals, $state) {
        $scope.locals = locals;

        $scope.hide = function () {
            if ($scope.locals.reload) {
                $state.reload();
            }
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            if ($scope.locals.reload) {
                $state.reload();
            }
            $mdDialog.cancel();
        };

        $scope.confirm = function () {
            // if ($scope.locals.reload) {
            //     $state.reload();
            // }

            $mdDialog.hide($scope.locals);
        };
    }
    PopUpInfoCtrl.$inject = ['$scope', '$mdDialog', 'locals', '$state'];
    $scope.showPopUp = function (ev, head, content, text, target, reload) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-small.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                reload: reload,
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function (data) {
            $timeout(function () {
                $('#barcode').find('input').focus();
            });
        }, function () {
            $timeout(function () {
                $('#barcode').find('input').focus();
            });
        });
    };
// @TODO <HEALTH2019>
    $scope.healthReport = {
        year: -1,
        minMonth: -1,
        maxMonth: -1,
        month: -1,
        transfers: [],
        numberOfPages: 0,
        page: 0,
        current: 0,
        setNowHealth: function() {
            var now = $filter('nowYearAndMonth')('');
            $scope.healthReport.year = now.year;
            $scope.healthReport.month = now.month;

            $scope.healthReport.filterTransfer();
        },
        loadTransfers: function (page) {
            var criteria = {
                month: $scope.healthReport.month,
                year: $scope.healthReport.year
            }
            zochaHealthInsuranceService.dataTransferList(criteria).then(function (data) {
                if (data.status === 200) {
                    $scope.healthReport.transfers = data.data.data;
                    $scope.healthReport.numberOfPages = data.data.pages;
                }
            });
        },
        filterTransfer: function(type) {
            var now = $filter('nowYearAndMonth')('');

            // min block
            if ($scope.healthReport.year === 2018) {
                $scope.healthReport.minMonth = 8;

                if (type === 'YEAR') {
                    $scope.healthReport.month = 8;
                }
            } else {
                $scope.healthReport.minMonth = 1;
            }

            // max block
            if ($scope.healthReport.year === now.year) {
                $scope.healthReport.maxMonth = now.month;
            } else {
                $scope.healthReport.maxMonth = 12;
            }

            $scope.healthReport.loadTransfers($scope.healthReport.page);
        },
        transferSend: function(id, sum) {
            if (!sum) {
                return 0;
            }

            var data = {
                branch: {
                    id: id
                },
                month: $scope.healthReport.month,
                year: $scope.healthReport.year
            };
            zochaHealthInsuranceService.sendTransfer(data).then(function (data) {
                if (data.status === 200) {
                    $scope.healthReport.loadTransfers($scope.healthReport.current);
                }
            });
        },
        pageChanged: function (page) {
            $scope.healthReport.loadTransfers(page);
            $scope.healthReport.current = page;
        }
    };
// @TODO </HEALTH2019>

    $scope.healthPzuwReport = {
        year: -1,
        minMonth: -1,
        maxMonth: -1,
        month: -1,
        transfers: [],
        numberOfPages: 0,
        page: 0,
        current: 0,
        initialize: function() {
            let now = $filter('nowYearAndMonth')('');
            $scope.healthPzuwReport.year = now.year;
            $scope.healthPzuwReport.month = now.month;

            $scope.healthPzuwReport.filterTransfer();
        },
        loadTransfers: function (page) {
            let criteria = {
                month: $scope.healthPzuwReport.month,
                year: $scope.healthPzuwReport.year
            }
            zochaPzuwHealthInsuranceService.getInsurerTransfers(criteria).then(function (data) {
                if (data.status === 200) {
                    $scope.healthPzuwReport.transfers = data.data.data;
                    $scope.healthPzuwReport.numberOfPages = data.data.pages;
                }
            });
        },
        filterTransfer: function(type) {
            let now = $filter('nowYearAndMonth')('');

            // min block
            if ($scope.healthPzuwReport.year === 2022) {
                $scope.healthPzuwReport.minMonth = 11;

                if (type === 'YEAR') {
                    $scope.healthPzuwReport.month = 11;
                }
            } else {
                $scope.healthPzuwReport.minMonth = 1;
            }

            // max block
            if ($scope.healthPzuwReport.year === now.year) {
                $scope.healthPzuwReport.maxMonth = now.month;
            } else {
                $scope.healthPzuwReport.maxMonth = 12;
            }

            $scope.healthPzuwReport.loadTransfers($scope.healthPzuwReport.page);
        },
        transferSend: function(transfer) {
            if (!transfer.amount) {
                return 0;
            }

            zochaPzuwHealthInsuranceService.sendInsurerTransfer(transfer).then(function (data) {
                if (data.status === 200) {
                    $scope.healthPzuwReport.loadTransfers($scope.healthPzuwReport.current);
                }
            });
        },
        pageChanged: function (page) {
            $scope.healthPzuwReport.loadTransfers(page);
            $scope.healthPzuwReport.current = page;
        }
    };

    $scope.isEndOfAccession = function () {
        return packageService.isEndOfAccessionZocha();
    };
}]);
